import { Albums as AlbumsModule } from "../modules/Albums/Albums";

const Albums = () => {
  return <AlbumsModule />;
};

export default Albums;
